var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Body } from '@lendi-ui/typography';
import React from 'react';
import { EmptySpace } from './style';
import { LENDI_BOT_IDENTITY } from '../../../../twilio/states/state/types';
import { getFirstNameForBrand } from '../../../../utils';
export var TypingIndicator = function (_a) {
    var identity = _a.identity, members = _a.members;
    members = members.map(function (member) {
        return member.identity === LENDI_BOT_IDENTITY ? __assign(__assign({}, member), { firstName: getFirstNameForBrand() }) : member;
    });
    var otherTypingMembers = members.filter(function (member) { return member.identity !== identity && member.isTyping; });
    var indicatorMessage = '';
    if (otherTypingMembers.length === 0) {
        return React.createElement(EmptySpace, null);
    }
    else if (otherTypingMembers.length === 1) {
        var _b = otherTypingMembers[0].firstName, firstName = _b === void 0 ? 'Member' : _b;
        indicatorMessage = "".concat(firstName, " is typing...");
    }
    else {
        var firstNames = otherTypingMembers.map(function (member) { return "".concat(member.firstName, " ").concat(member.lastName); });
        indicatorMessage = firstNames.slice(0, otherTypingMembers.length - 1).join(', ');
        indicatorMessage += " and ".concat(firstNames[firstNames.length - 1], " ");
        indicatorMessage += 'are typing...';
    }
    return (React.createElement(Body, { size: "xxs", color: "shade.700", mt: "xxxs" }, indicatorMessage));
};
//# sourceMappingURL=index.js.map